export const tutorialVideos = [
    {
        title: "Downloading Free & Public Neuroscience Data with BossDB.org",
        youtubeLink: "https://youtu.be/gic1O3AM3Iw",
        youtubeEmbed: "https://www.youtube.com/embed/gic1O3AM3Iw"
    },   
    {
        title: "Getting Started: Creating a BossDB User Account",
        youtubeLink: "https://youtu.be/eVNr6Pzxoh8",
        youtubeEmbed: "https://www.youtube.com/embed/eVNr6Pzxoh8"
    },     
    {
        title: "Uploading data to BossDB.org",
        youtubeLink: "https://youtu.be/gbbfWDThELU",
        youtubeEmbed: "https://www.youtube.com/embed/gbbfWDThELU"
    },
    {
        title: "How to use Neuroglancer",
        youtubeLink: "https://youtu.be/TwBTyWWnbxc",
        youtubeEmbed: "https://www.youtube.com/embed/TwBTyWWnbxc"
    },    
]

